export default __webpack_public_path__ + "static/media/background.cd345f83.png";